import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'rx-no-data',
  templateUrl: './rx-no-data.component.html',
  styleUrls: ['./rx-no-data.component.scss'],
  imports: [CommonModule],
})
export class RxNoDataComponent implements OnInit {
  @ViewChild('content', { static: true }) content: ElementRef;
  @Input() data: any;

  constructor() {}

  ngOnInit() {}

  hasContent() {
    return (
      this.content.nativeElement.childNodes.length > 0 &&
      Boolean(this.content.nativeElement.childNodes[0].textContent.trim())
    );
  }
}
